export class SpeechRecArtifact {
    Attempts: [
        {
            WasMarkedCorrect: boolean;
            AttemptDate: string;
            TargetPhrases: string[];
            EngineResults: SpeechRecEngineResult[];
            Recording: string;
        }
    ];

    static ParseSpeechRecArtifact(untypedArtifact): SpeechRecArtifact {
        var decodedData = window.atob(untypedArtifact.Data);
        var speechRecArtifact = JSON.parse(decodedData);
        //var speechRecArtifact = new SpeechRecArtifact();
        // speechRecArtifact = {
        //     Attempts: [
        //         {
        //             WasMarkedCorrect: speechRecData.Attempts[0].WasMarkedCorrect,
        //             AttemptDate: speechRecData.Attempts[0].AttemptDate,
        //             TargetPhrases: speechRecData.Attempts[0].TargetPhrases,
        //             EngineResults: speechRecData.Attempts[0].SpeechRecEngineResult,
        //             Recording: speechRecData.Attempts[0].WasMarkedCorrect,
        //         }
        //     ]
        // };
        //decodedData = speechRecData.Attempts[0].Recording;


        return speechRecArtifact;
    }
}

export class SpeechRecEngineResult {
    EngineName: string;
    WasMarkedCorrect: boolean;
    ResultBody: string;
    Scores: number[];
}